import { render, staticRenderFns } from "./OdocRoutesInput.vue?vue&type=template&id=5978df8d"
import script from "./OdocRoutesInput.vue?vue&type=script&lang=js"
export * from "./OdocRoutesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports